export const materieelsoorten = {
  sprinters: [
    'SNG-3',
    'SNG-4',
    'SNG-3T',
    'SNG-4T',
    'SLT-4',
    'SLT-6',
    'SLT-6S',
    'FLIRT TAG-2',
    'FLIRT FFF-3',
    'FLIRT FFF-4',
  ],
  intercities: ['ICM-3', 'ICM-4', 'VIRM-4', 'VIRM-6', 'DDZ-4', 'DDZ-6', 'ICNG-5', 'ICNG-8', 'ICNG-8B'],
  internationaal: [
    'TGV-PBA',
    'EUR-PBA',
    'NEO-ICE3',
    'E-LOC-VECT',
    'DB-BER9-9',
    'DB-B5-5',
    'DB-B6-6',
    'DB-B7-7',
    'DB-B8-8',
    'SWB6-25KV-2+6',
    'ICNG-8B',
  ],
};
